import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Zap, TrendingUp, ShieldCheck } from 'lucide-react';

const benefitList = [
    {
        icon: Zap,
        title: "Agilidade Máxima",
        description: "Reduza o tempo de atendimento em até 40% com fluxos de pedidos automatizados."
    },
    {
        icon: TrendingUp,
        title: "Vendas Crescentes",
        description: "Aumente seu ticket médio através de dados precisos sobre o comportamento dos seus clientes."
    },
    {
        icon: ShieldCheck,
        title: "Organização Total",
        description: "Tenha a segurança de que cada centavo e cada reserva estão sob seu controle total."
    }
];

const Benefits: React.FC = () => {
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start end", "end start"]
    });

    // Cards se inclinam levemente conforme o scroll passa
    const rotateY = useTransform(scrollYProgress, [0, 1], [5, -5]);

    return (
        <section ref={containerRef} className="py-32 px-6 bg-background perspective-1000">
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {benefitList.map((benefit, i) => (
                        <motion.div
                            key={i}
                            style={{ rotateY }}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.1, duration: 0.8 }}
                            className="p-10 rounded-[40px] bg-[#0f0f0f] border border-white/5 space-y-6 hover:border-primary/20 transition-colors group cursor-default"
                        >
                            <div className="w-14 h-14 rounded-2xl bg-white/5 flex items-center justify-center group-hover:scale-110 group-hover:bg-primary/10 transition-all">
                                <benefit.icon className="w-7 h-7 text-primary" />
                            </div>
                            <h3 className="text-2xl font-bold text-white tracking-tight">{benefit.title}</h3>
                            <p className="text-lg text-secondary leading-relaxed font-medium">
                                {benefit.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Benefits;
